import React, { useMemo } from 'react';
import { buildRadioRowSelection } from 'components/RecordsListView/buildRadioRowSelection';
import RowItem from '../Components/RowItem';
import { OperationSummary } from '../Components/types';

interface UseListViewColumnsProps {
  selectedId: string | null;
  onSelectId: (id: string | null) => void;
  allTags?: Array<{ id: string; name: string; color: string }>;
  searchTerm?: string;
}

const useListViewColumns = ({
  selectedId,
  onSelectId,
  allTags,
  searchTerm = ''
}: UseListViewColumnsProps) => {
  const rowSelection = useMemo(
    () =>
      buildRadioRowSelection<OperationSummary>({
        selectedId,
        onSelectId,
        getKey: record => record.id,
        namePrefix: 'item'
      }),
    [selectedId, onSelectId]
  );

  const columns = useMemo(
    () => [
      {
        dataIndex: 'name',
        key: 'name',
        render: (_: any, record: OperationSummary) => (
          <RowItem
            operation={record}
            isSelected={selectedId === record.id}
            allTags={allTags}
            searchTerm={searchTerm}
          />
        )
      }
    ],
    [selectedId, allTags, searchTerm]
  );

  return {
    rowSelection,
    columns
  };
};

export default useListViewColumns;
